module.exports = __webpack_public_path__ + "img/tg.bdae4e62.svg";